export interface StarIconProps {
  className?: string;
}

export function StarIcon({ className }: StarIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52447 1.46338C7.67415 1.08637 8.32585 1.08637 8.47553 1.46338L10.0409 5.43075C10.1039 5.58847 10.2516 5.69336 10.4196 5.69336H14.6071C15.0068 5.69336 15.1724 6.21698 14.8549 6.43075L11.4185 8.88517C11.2834 8.98481 11.2242 9.15992 11.2721 9.32057L12.8375 13.2879C12.9872 13.665 12.5448 13.9769 12.2273 13.7631L8.79088 11.3087C8.65583 11.2091 8.47311 11.2091 8.33806 11.3087L4.90163 13.7631C4.58411 13.9769 4.14178 13.665 4.29146 13.2879L5.85686 9.32057C5.90477 9.15992 5.84558 8.98481 5.71053 8.88517L2.27409 6.43075C1.95657 6.21698 2.12217 5.69336 2.5219 5.69336H6.70937C6.87737 5.69336 7.02507 5.58847 7.08814 5.43075L7.52447 1.46338Z"
        fill="#05B45B"
      />
    </svg>
  );
}
